module.exports = __webpack_public_path__ + "img/DF_white_arrow_right_desktop.ae704f8b.svg";